import React from 'react';

const ScholarshipCTA = ({ title, subtitle, variant = 'default' }) => {
  const handleClick = () => {
    const admissionsSection = document.getElementById('admissions');
    if (admissionsSection) {
      admissionsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  // Variante para después del Manifiesto (más emocional)
  if (variant === 'manifesto') {
    return (
      <section className="relative py-20 bg-gradient-to-b from-black via-[#0A0A0A] to-black overflow-hidden">
        {/* Efecto de luz */}
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-teal-900/20 via-transparent to-transparent" />
        
        <div className="relative z-10 max-w-4xl mx-auto px-4 text-center">
          <div className="inline-block mb-6">
            <span className="text-5xl">🎓</span>
          </div>
          
          <h3 className="text-4xl md:text-5xl font-bold text-white mb-4">
            ¿Listo para ser libre?
          </h3>
          
          <p className="text-xl text-gray-300 mb-8 max-w-2xl mx-auto">
            No todos califican. Solo aceptamos personas comprometidas con su libertad.
          </p>
          
          <button
            onClick={handleClick}
            className="group relative inline-flex items-center gap-3 px-8 py-4 
              bg-gradient-to-r from-[#D4AF37] to-[#F4E4B7] 
              text-black font-bold text-lg rounded-lg 
              transform transition-all duration-300 
              hover:scale-105 hover:shadow-2xl hover:shadow-[#D4AF37]/50"
          >
            <span>Solicitar Beca Libertad</span>
            <svg 
              className="w-6 h-6 transform group-hover:translate-x-1 transition-transform" 
              fill="none" 
              viewBox="0 0 24 24" 
              stroke="currentColor"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
            </svg>
          </button>
          
          <p className="text-sm text-gray-500 mt-4">
            Aplicación gratuita • Respuesta en menos de 48 horas hábiles
          </p>
        </div>
      </section>
    );
  }

  // Variante para después del Curriculum (más práctica)
  if (variant === 'curriculum') {
    return (
      <section className="relative py-16 bg-black border-y border-[#D4AF37]/20">
        <div className="max-w-5xl mx-auto px-4">
          <div className="bg-gradient-to-r from-[#0A0A0A] via-[#1a4d5c]/10 to-[#0A0A0A] 
            border border-[#D4AF37]/30 rounded-2xl p-8 md:p-12">
            <div className="grid md:grid-cols-2 gap-8 items-center">
              <div>
                <h3 className="text-3xl md:text-4xl font-bold text-white mb-4">
                  {title || 'Este programa puede ser tuyo'}
                </h3>
                <p className="text-lg text-gray-300 mb-6">
                  {subtitle || 'Aplica a la Beca Libertad y accede a formación de élite sin barreras económicas.'}
                </p>
                <ul className="space-y-2 text-gray-400">
                  <li className="flex items-center gap-2">
                    <span className="text-[#D4AF37]">✓</span>
                    Hasta 100% de cobertura del MBA
                  </li>
                  <li className="flex items-center gap-2">
                    <span className="text-[#D4AF37]">✓</span>
                    Proceso 100% online
                  </li>
                  <li className="flex items-center gap-2">
                    <span className="text-[#D4AF37]">✓</span>
                    Respuesta en menos de 48 horas hábiles
                  </li>
                </ul>
              </div>
              
              <div className="text-center md:text-right">
                <button
                  onClick={handleClick}
                  className="group inline-flex items-center gap-3 px-8 py-4 
                    bg-gradient-to-r from-[#D4AF37] to-[#F4E4B7] 
                    text-black font-bold text-lg rounded-lg 
                    transform transition-all duration-300 
                    hover:scale-105 hover:shadow-2xl hover:shadow-[#D4AF37]/50"
                >
                  <span>Solicitar Beca Ahora</span>
                  <svg 
                    className="w-6 h-6 transform group-hover:translate-x-1 transition-transform" 
                    fill="none" 
                    viewBox="0 0 24 24" 
                    stroke="currentColor"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                  </svg>
                </button>
                <p className="text-sm text-gray-500 mt-4">
                  🔥 Cupos limitados disponibles
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }

  // Variante default (simple)
  return (
    <section className="py-12 bg-black">
      <div className="max-w-4xl mx-auto px-4 text-center">
        <button
          onClick={handleClick}
          className="group inline-flex items-center gap-3 px-8 py-4 
            bg-gradient-to-r from-[#D4AF37] to-[#F4E4B7] 
            text-black font-bold text-lg rounded-lg 
            transform transition-all duration-300 
            hover:scale-105 hover:shadow-2xl hover:shadow-[#D4AF37]/50"
        >
          <span>Solicitar Beca Libertad</span>
          <svg 
            className="w-6 h-6 transform group-hover:translate-x-1 transition-transform" 
            fill="none" 
            viewBox="0 0 24 24" 
            stroke="currentColor"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
          </svg>
        </button>
      </div>
    </section>
  );
};

export default ScholarshipCTA;
